import { render, staticRenderFns } from "./scene-index-body.vue?vue&type=template&id=62e6048a&"
import script from "./scene-index-body.vue?vue&type=script&lang=js&"
export * from "./scene-index-body.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports